import { useEffect, useState, useRef } from "react";
import Sider from "../../comps/sider/main";
import './main.css';
import {TagTwoTone, ClockCircleOutlined, CommentOutlined, UserSwitchOutlined, EyeInvisibleOutlined, DeleteOutlined, PlusOutlined, SendOutlined, ThunderboltOutlined, GlobalOutlined, UploadOutlined, UserAddOutlined, CopyOutlined, CrownOutlined, FireFilled, PlusSquareOutlined, AppleFilled, MailOutlined } from '@ant-design/icons';
import { Alert, notification ,Card, InputNumber, Switch, Drawer, Radio, Input, Tag, Divider, Select, Button, Collapse, Upload, Tooltip, message, Popconfirm, Checkbox, Image } from 'antd';
import { EditText, EditTextarea } from 'react-edit-text';
import 'react-edit-text/dist/index.css';
import axios from 'axios';
import callAPI from "../../comps/fetch/main";
import { json } from "react-router-dom";
import Title from "antd/es/skeleton/Title";
import AccessOrNot from "../../funcs/accessOrNot";
import { v4 as uuidv4 } from 'uuid';
import {InstaDMLayout, InstagramCommentLayout } from "../instaDMLayout/main";
import CrownReturn from '../crownPremium/main'
import { BsCashCoin, BsMagnet  } from "react-icons/bs";

import { PhoneMockup } from 'react-daisyui'
import ButtonTemplateComp from "./buttonTemplate";

import { Row, Col } from "antd";
import { CheckCircleFilled, DeploymentUnitOutlined } from "@ant-design/icons";


  // const [api] = notification.useNotification();
const { TextArea } = Input;



const DMTypeCards = ({state, setData}) => {
  const selected = state?.auto_reply?.dm_reply_type || "single";

  const setType = (value) => {
    let tempState = {
      ...state, auto_reply:{...state.auto_reply, dm_reply_type: value},
      
    }
    console.log("-=-=-=-=-=--tempState" , tempState)

    setData(tempState);
  };

  const cardStyle = (isActive) => ({
    borderRadius: 12,
    border: isActive ? "2px solid #1677ff" : "1px solid #f0f0f0",
    boxShadow: isActive ? "0 6px 18px rgba(22,119,255,0.15)" : "0 2px 8px rgba(0,0,0,0.06)",
    transition: "all .2s ease",
    cursor: "pointer",
    height: "100%",
  });

  const title = (text, isActive) => (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <span>{text}</span>
      {isActive && <CheckCircleFilled style={{ color: "#1677ff", fontSize: 16 }} />}
    </div>
  );

  return (
    <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
      <Col xs={24} sm={12}>
        <Card
          hoverable
          style={cardStyle(selected === "single")}
          onClick={() => setType("single")}
          aria-selected={selected === "single"}
          role="button"
        >
          <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
            <SendOutlined style={{ fontSize: 22, marginTop: 2 }} />
            <div>
              <div style={{ fontSize: 16, fontWeight: 600 }}>
                {title("Single Message", selected === "single")}
              </div>
              <div style={{ color: "#666", marginTop: 6 }}>
                Send one DM immediately after the trigger.
              </div>
            </div>
          </div>
        </Card>
      </Col>

      <Col xs={24} sm={12}>
        <Card
          hoverable
          style={cardStyle(selected === "sequence")}
          onClick={() => setType("sequence")}
          aria-selected={selected === "sequence"}
          role="button"
        >
          <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
            <DeploymentUnitOutlined style={{ fontSize: 22, marginTop: 2 }} />
            <div>
              <div style={{ fontSize: 16, fontWeight: 600 }}>
                {title("DM Sequence", selected === "sequence")} 
              </div>
              <div style={{ color: "#666", marginTop: 6 }}>
                Send multiple DMs with images and voice notes.
              </div>
              {/* <Tag color="purple">Beta</Tag> */}
            </div>
          </div>
        </Card>
      </Col>
    </Row>
  );
};



let supported_currency = [
  { "label": "🇮🇳 Indian Rupee (₹)", "value": "INR" },
  { "label": "🇺🇸 US Dollar ($)", "value": "USD" },
  { "label": "🇮🇩 Indonesian Rupiah (Rp)", "value": "IDR" },
  { "label": "🇦🇪 UAE Dirham (د.إ)", "value": "AED" },
  { "label": "🇦🇱 Albanian Lek (L)", "value": "ALL" },
  { "label": "🇦🇲 Armenian Dram (֏)", "value": "AMD" },
  { "label": "🇦🇷 Argentine Peso ($)", "value": "ARS" },
  { "label": "🇦🇺 Australian Dollar ($)", "value": "AUD" },
  { "label": "🇦🇼 Aruban Florin (Afl)", "value": "AWG" },
  { "label": "🇦🇿 Azerbaijan Manat (₼)", "value": "AZN" },
  { "label": "🇧🇦 Convertible Mark (KM)", "value": "BAM" },
  { "label": "🇧🇧 Barbadian Dollar (Bds$)", "value": "BBD" },
  { "label": "🇧🇩 Bangladeshi Taka (৳)", "value": "BDT" },
  { "label": "🇧🇬 Bulgarian Lev (лв)", "value": "BGN" },
  { "label": "🇧🇭 Bahraini Dinar (.د.ب)", "value": "BHD" },
  { "label": "🇧🇮 Burundi Franc (FBu)", "value": "BIF" },
  { "label": "🇧🇲 Bermudian Dollar ($)", "value": "BMD" },
  { "label": "🇧🇳 Brunei Dollar (B$)", "value": "BND" },
  { "label": "🇧🇴 Bolivian Boliviano (Bs.)", "value": "BOB" },
  { "label": "🇧🇷 Brazilian Real (R$)", "value": "BRL" },
  { "label": "🇧🇸 Bahamian Dollar (B$)", "value": "BSD" },
  { "label": "🇧🇹 Bhutanese Ngultrum (Nu.)", "value": "BTN" },
  { "label": "🇧🇼 Botswana Pula (P)", "value": "BWP" },
  { "label": "🇧🇿 Belize Dollar (BZ$)", "value": "BZD" },
  { "label": "🇨🇦 Canadian Dollar (C$)", "value": "CAD" },
  { "label": "🇨🇭 Swiss Franc (CHF)", "value": "CHF" },
  { "label": "🇨🇱 Chilean Peso ($)", "value": "CLP" },
  { "label": "🇨🇳 Chinese Yuan (¥)", "value": "CNY" },
  { "label": "🇨🇴 Colombian Peso ($)", "value": "COP" },
  { "label": "🇨🇷 Costa Rican Colón (₡)", "value": "CRC" },
  { "label": "🇨🇺 Cuban Peso (CUP)", "value": "CUP" },
  { "label": "🇨🇿 Czech Koruna (Kč)", "value": "CZK" },
  { "label": "🇩🇯 Djiboutian Franc (Fdj)", "value": "DJF" },
  { "label": "🇩🇰 Danish Krone (kr)", "value": "DKK" },
  { "label": "🇩🇴 Dominican Peso (RD$)", "value": "DOP" },
  { "label": "🇩🇿 Algerian Dinar (د.ج)", "value": "DZD" },
  { "label": "🇪🇬 Egyptian Pound (E£)", "value": "EGP" },
  { "label": "🇪🇹 Ethiopian Birr (Br)", "value": "ETB" },
  { "label": "🇪🇺 Euro (€)", "value": "EUR" },
  { "label": "🇫🇯 Fijian Dollar (FJ$)", "value": "FJD" },
  { "label": "🇬🇧 British Pound (£)", "value": "GBP" },
  { "label": "🇬🇭 Ghanaian Cedi (₵)", "value": "GHS" },
  { "label": "🇭🇰 Hong Kong Dollar (HK$)", "value": "HKD" },
  { "label": "🇭🇷 Croatian Kuna (kn)", "value": "HRK" },
  { "label": "🇭🇺 Hungarian Forint (Ft)", "value": "HUF" },
  { "label": "🇮🇱 Israeli Shekel (₪)", "value": "ILS" },
  { "label": "🇮🇶 Iraqi Dinar (ع.د)", "value": "IQD" },
  { "label": "🇮🇸 Icelandic Krona (kr)", "value": "ISK" },
  { "label": "🇯🇵 Japanese Yen (¥)", "value": "JPY" },
  { "label": "🇰🇪 Kenyan Shilling (KSh)", "value": "KES" },
  { "label": "🇰🇷 South Korean Won (₩)", "value": "KRW" },
  { "label": "🇰🇼 Kuwaiti Dinar (د.ك)", "value": "KWD" },
  { "label": "🇱🇰 Sri Lankan Rupee (Rs)", "value": "LKR" },
  { "label": "🇲🇾 Malaysian Ringgit (RM)", "value": "MYR" },
  { "label": "🇲🇽 Mexican Peso ($)", "value": "MXN" },
  { "label": "🇳🇬 Nigerian Naira (₦)", "value": "NGN" },
  { "label": "🇳🇴 Norwegian Krone (kr)", "value": "NOK" },
  { "label": "🇳🇿 New Zealand Dollar ($)", "value": "NZD" },
  { "label": "🇴🇲 Omani Rial (﷼)", "value": "OMR" },
  { "label": "🇵🇰 Pakistani Rupee (Rs)", "value": "PKR" },
  { "label": "🇵🇭 Philippine Peso (₱)", "value": "PHP" },
  { "label": "🇵🇱 Polish Złoty (zł)", "value": "PLN" },
  { "label": "🇶🇦 Qatari Riyal (﷼)", "value": "QAR" },
  { "label": "🇷🇺 Russian Ruble (₽)", "value": "RUB" },
  { "label": "🇸🇦 Saudi Riyal (﷼)", "value": "SAR" },
  { "label": "🇸🇪 Swedish Krona (kr)", "value": "SEK" },
  { "label": "🇸🇬 Singapore Dollar (S$)", "value": "SGD" },
  { "label": "🇿🇦 South African Rand (R)", "value": "ZAR" },
  { "label": "🇿🇲 Zambian Kwacha (ZK)", "value": "ZMW" }
];


function CommentPreview({data, igData}){


      function extractFirstLink(text) {
        if (text == null || text == undefined)
          return null
      const pattern = /(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/[^\s"'<>()]*)?/g;
      const matches = text.match(pattern);
      return matches ? matches[0] : null;
    }
  
    const [tempData,setTempData] = useState(data)
    const [linkPreview, setLinkPreview] = useState()
    const [loadingstate, setloadingState] = useState()
    const [cachedPreview, setCahcedPreview] = useState({})
  
  //    useEffect( () => {

    
  //   if((data.auto_reply.dm_template_type || "text") == "text"){
  //     setLinkPreview()
  //     if ( extractFirstLink(data?.auto_reply?.dms?.[0]) != null ){
  //         callAPI( { url :  "/short_url" , method: "POST" , body:{"url" :extractFirstLink(data?.auto_reply?.dms?.[0]),
  //           "only_preview":true,  }, loadingState: setloadingState, dataState: (data) => {
  //             // setCahcedPreview({...cachedPreview  })
  //               setLinkPreview(data.data)
  //               // console.log(data.data)
  //           }})
      
  //   }
  // }

  // }, [data])
  if((data.auto_reply.dm_template_type || "text") == "text"){

  }



  return <div style={{display:"flex"}}>

    <InstagramCommentLayout data={data} igData={igData} />

    {data?.auto_reply?.enable_dm_reply == true && 
    <InstaDMLayout>
      {
        data.auto_reply?.welcome_message?.enabled == true &&

        <>
        <div className="card-message" style={{borderRadius:"10px"}}>
        {/* <img src={data?.sp_product?.image?.src} /> */}
        <div className="card-content">
        <h3>{data?.auto_reply?.welcome_message?.text}</h3>
        {/* <p>{data?.sp_product?.description }</p> */}
        <div className="card-button">
        {data?.auto_reply?.welcome_message?.button_text}
        </div>
        {/* <div className="card-button">
        Visit website
        </div> */}
        </div>


      </div>
        <div className="insta-text-message from-user" >
        <div className="card-content" style={{paddingBottom:"10px"}}>
        <h3>{data?.auto_reply?.welcome_message?.button_text}</h3>
      </div>

      </div>
      </>
      }
      {
        data.auto_reply?.followers_only == true &&
        <>
        <div className="card-message" style={{borderRadius:"10px"}}>
        {/* <img src={data?.sp_product?.image?.src} /> */}
        <div className="card-content">
        <h3>{data?.auto_reply?.ask_follow?.title || "🔓 Follow to Unlock Exclusive Content"}</h3>
        <p>{data?.auto_reply?.ask_follow?.description || "👋 Looks like you haven't followed me yet! 🤔 Follow to unlock exclusive content! 🔓" }</p>
        <div className="card-button">
        {data?.auto_reply?.ask_follow?.open_profile_text || "Follow Me"}
        </div>
        <div className="card-button">
        {data?.auto_reply?.ask_follow?.button_text || "Started following you! 👍"}
        </div>

        {/* <div className="card-button">
        Visit website
        </div> */}
        </div>

      </div>

        <div className="insta-text-message from-user" >
        <div className="card-content" style={{paddingBottom:"10px"}}>
        <h3>{data?.auto_reply?.ask_follow?.button_text || "Started following you! 👍"}</h3>
        </div>
        </div>
      </>
      }

      { (data?.auto_reply?.dm_reply_type != "sequence" && data?.auto_reply?.enable_dm_reply == true) &&
      <div>
        
        {(((data.auto_reply.dm_template_type || "text") == "text") && data?.auto_reply?.dms?.[0] ) &&  <div className="insta-text-message" >
        <div className="card-content" style={{paddingBottom:"10px", marginBottom:"10px"}}>
          <p style={{ whiteSpace: "pre-line" }}>{data?.auto_reply?.dms?.[0]}</p>
        </div>
      </div>}
      

      
       {data.auto_reply.dm_template_type  == "button"  && 
       <div className="card-message" style={{borderRadius:"10px", marginBottom:"10px"}}>
        <img src={data.auto_reply.cover_image} />
        <div className="card-content">
        <h3>{data?.auto_reply.title }</h3>
        <p>{data?.auto_reply?.subtitle }</p>
        {data?.auto_reply.buttons.map((button, index) =>
        <div className="card-button">
        {button.title}
        </div>
        )}

        </div>
        </div>}
      

      
       {data.auto_reply.dm_template_type  == "products"  && 
       <div style={{display:"flex", flexDirection:"row", marginBottom:"10px",overflowX:"scroll", flexWrap:"nowrap", maxWidth:"100%"}}>
       {data.auto_reply.products.map( (message , item) =>
       <div className="card-message" style={{borderRadius:"10px"}}>
        <img src={message.image_url} />
        <div className="card-content">
        <h3>{message.title }</h3>
        <p>{message?.subtitle }</p>
        {message.buttons.map((button, index) =>
        <div className="card-button">
        {button.title}
        </div>
        )}

        </div>
        </div>
       )}
       </div>}
      

       </div>
      }
      {
        (data?.auto_reply?.dm_reply_type == "sequence" && data?.auto_reply?.enable_dm_reply == true) && data?.auto_reply?.messages?.map(
        (msg) => {

          console.log("==========msg",msg)

          
            if(msg?.type == "text"){

              return(
            <>
            { msg?.delay > 0 && <Tag icon={<ClockCircleOutlined />} style={{margin:"10px"}} color="purple">Delay {msg.delay} Min</Tag> }
            <div className="insta-text-message" >
            <div className="card-content" style={{paddingBottom:"10px", marginBottom:"10px"}}>
              <p style={{ whiteSpace: "pre-line" }}>{msg.dms?.[0] || "<Empty>"}</p>
            </div>
            </div>
          </>)     
          
        }
        
        if(msg?.type == "button" ){
                
   
       return (
       <>
            { msg?.delay > 0 && <Tag icon={<ClockCircleOutlined />} style={{margin:"10px"}} color="purple">Delay {msg.delay} Min</Tag> }
       
       
       <div className="card-message" style={{borderRadius:"10px", marginBottom:"10px"}}>
        <img src={msg?.cover_image} />
        <div className="card-content">
        <h3>{msg?.title }</h3>
        <p>{msg?.subtitle }</p>
        {msg?.buttons.map((button, index) =>
        <div className="card-button">
        {button.title}
        </div>
        )}

        </div>
        </div>
        </>
        )
      }
        if(msg?.type == "audio" ){
                
   
       return (
        <>
            { msg?.delay > 0 && <Tag icon={<ClockCircleOutlined />} style={{margin:"10px"}} color="purple">Delay {msg.delay} Min</Tag> }

          <audio style={{maxWidth:"80%", marginBottom:"10px"}} controls src={msg?.audio_url}>Your browser does not support the audio element.</audio>
        </>
        )
      }

      if(msg?.type == "image" ){

        return <>
            { msg?.delay > 0 && <Tag icon={<ClockCircleOutlined />} style={{margin:"10px"}} color="purple">Delay {msg.delay} Min</Tag> }
        
        

        <Image style={{borderRadius:"10px", marginBottom:"10px", maxHeight:"400px", maxWidth:"90%", objectFit: "cover", }} src={msg?.image_url}/>
      </>
      }

          }

        
        ) }
      

    </InstaDMLayout>
}

  </div>
}

function AutoReply(props) {
  const [tags, setTags] = useState([]);
  const [comments, setComments] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [commentValue, setCommentValue] = useState('');
  const [isAddingTag, setIsAddingTag] = useState(false); // Combined state for tag/comment input visibility
  const [addingType, setAddingType] = useState(''); // Identify which input is being added (tag or comment)
  const inputRef = useRef(null);
  const commentRef = useRef(null);
  const [preSignedURL, setPreSignedURL] = useState()
  const [thumnailURL, setThumbnailURL] = useState(props.state.auto_reply.cover_image)
  const [loading, setLoading] = useState()

  const [prevStateCopy, setPrevStateCopy] = useState()
  const [prevState, setPrevState] = useState()

  const [localState, setLocalState] = useState()

  const [messageApi, contextHolder] = message.useMessage();


  // Helper function: get extension from MIME type
const getExtensionFromMime = (mimeType) => {
  if (!mimeType) return "bin"; // fallback
  const parts = mimeType.split("/");
  if (parts.length === 2) {
    // e.g. image/png → "png"
    return parts[1];
  }
  return "bin";
};

  const uploadFileToS3 = async (file, path) => {
    try {
      messageApi.open({
        type: 'loading',
        content: 'Uploading, Please wait...',
        duration: 0,
        key: 'payment-process'
      });
      const extension = getExtensionFromMime(file.type);


      let prod_url = `https://4iav7nkzgsu2jbpidrdt7seiri0lcfhk.lambda-url.ap-south-1.on.aws/generate_image_url?post_id=${path}&ext=${extension}&custom_name=file`

      const presSignedResponse = await axios.get(prod_url, {
        headers: {
          "Authorization": localStorage.getItem("token")
        }
      });

      // console.log("======",presSignedResponse.data )

      // console.log("putting  file",file.type)

      const signedUrl = presSignedResponse.data.url;

      const response = await axios.put(signedUrl, file, {
        headers: {
          'Content-Type': file.type,
        },
      });


      if (response.status === 200) {
        // console.log("putting  file 200")
        // console.log('File uploaded successfully');
        messageApi.destroy()
        message.success("File uploaded successfully")
        // let url = `https://public-assets.instantdm.com/instantdm/public/${path}/media/image.jpg`
        // let url = `https://r2-public-image.sanjayhotaction.workers.dev/instantdm/public/${path}/media/image.jpg`
        let url = `https://public-assets.instantdm.com/instantdm/public/${path}/media/file.${extension}`
        return url


      } else {
        console.log("putting  file", response)
        console.log('Error uploading file');
        messageApi.destroy()
        message.error("Failed to upload")
      }
    } catch (error) {
      console.log('Error uploading file:', error);
      messageApi.destroy()
      message.error("Failed to upload")
    }
    return undefined
  };


  const TempFree = () => {

    return <Tooltip style={{}} title="Free and unlimited for now"><Tag icon={<ClockCircleOutlined />} color="purple" style={{ fontWeight: '500', fontSize: '12px', opacity: '.8', cursor: 'pointer' }}>Temporarily Free</Tag> </Tooltip>
  }


  const Beta = () => {

    return <Tooltip style={{ cursor: 'pointer' }} title="This is a beta feature, may not work as expected."><Tag color="purple" style={{ fontWeight: '500', fontSize: '12px', opacity: '.8', cursor: 'pointer' }} >Beta</Tag></Tooltip>
  }


  const handleClose = (item, tag_type = "") => {
    const newItems = tag_type === 'tag' ? props.state.auto_reply.triger_words.filter((tag) => tag !== item) : (props.state.auto_reply?.reply_comments || []).filter((comment) => comment !== item);
    if (tag_type === 'tag') {
      // setTags(newItems);
      // const newTags = props.state.auto_reply.triger_words.filter((tag) => tag !== removedTag);
      props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, triger_words: newItems } })
    } else {
      // setComments(newItems);
      props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, reply_comments: newItems } })
    }
  };

  const handleInputChange = (e) => {
    if (addingType === 'tag') {
      setInputValue(e.target.value);
    } else {
      setCommentValue(e.target.value);
    }
  };

  const handleInputConfirm = () => {
    const value = addingType === 'tag' ? inputValue : commentValue;
    if (value && ![...tags, ...comments].includes(value)) {
      if (addingType === 'tag') {

        props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, triger_words: [...props.state.auto_reply.triger_words, value] } })

      } else {
        props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, reply_comments: [...(props.state.auto_reply?.reply_comments || []), value] } })

      }
    }
    setIsAddingTag(false);
    setInputValue('');
    setCommentValue('');
  };

  const showInput = (type) => {
    setIsAddingTag(true);
    setAddingType(type);
  };

  const renderItem = (item, type) => (
    <span key={item} style={{ display: 'inline-block', marginBottom: '20px' }}>
      <Tag
        style={{ padding: '10px 10px', fontSize: '14px', gap: '10px' }}
        color="blue"
        closable
        onClose={(e) => {
          e.preventDefault();
          handleClose(item, type);
        }}
      >
        {item}
      </Tag>
    </span>
  );

  const handleImageUpload = async (file, customSave=null) => {
    if (file.thumbUrl != undefined) {
      props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, cover_image: undefined } })
      setThumbnailURL(undefined)
      return false
    }

    console.log("uploading image-=-=-=-")
    // Call your API to get the presigned URL
    // Upload the file to S3 using the presigned URL
    if(props.isNextPostReply){
      let temp_post_id = `${uuidv4()}_${props.state.post_id}`
      let url = await uploadFileToS3(file,temp_post_id);
      try {
        customSave(url)       
      } catch (error) {
        console.log("Errpr while saving the changes.....")

        props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, cover_image: url } })
        
      }

    }
    else{
    console.log("inside else-=-=-=-")

      let url = await uploadFileToS3(file, `${uuidv4()}_${props.state.post_id}`);
      
        try {
        customSave(url)
        console.log("Changes Saved.....")

    }
      catch (error){
        console.log("Errpr while saving the changes.....",error)
      props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, cover_image: url } })

      }
    }
  
  }


  const handleProductImageUpload = async (file, product_index) => {
    let products = props.state.auto_reply.products || []

    if (file.thumbUrl != undefined) {
      products[product_index].cover_image = undefined
    }
    else {
      let path = `${props.state.post_id}_${product_index}`
      let url = await uploadFileToS3(file, path);
      // console.log("======", url)
      products[product_index].image_url = url
    }
    // Upload the file to S3 using the presigned URL  
    props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, products: products } })
  }


  // useEffect(() => {
  //   let apiURL = `/generate_image_url?post_id=${props.state.post_id}`
  //   callAPI({ url: apiURL, method: "GET", loadingState: setLoading, dataState: setPreSignedURL })
  // }, [])


  useEffect(() => {


    if (prevStateCopy == undefined) {
      return
    }

    if (prevStateCopy == false && prevState != undefined) {
      props.setData(prevState)
      return
    }
    if (prevStateCopy == true) {
      let prev_automation = JSON.parse(localStorage.getItem("previous_config"))
      setPrevState(props.state)
      props.setData({ ...prev_automation, post_id: props.state.post_id, temp_post_id: props.state.temp_post_id, id: props.id, })

    }

  }, [prevStateCopy])

  useEffect(() => {

  }, [props.isStory])

  // console.log("===============", props.state)
  const tagChild = props.state.auto_reply.triger_words.map((tag) => renderItem(tag, 'tag'));
  const commentChild = (props.state.auto_reply.reply_comments || []).map((comment) => renderItem(comment, 'comment'));

  const tagPlusStyle = {
    background: 'blue',
    borderStyle: 'dashed',
  };



  const handleProductBtnNameChange = (e, index, btn_index) => {
    const products = [...props.state.auto_reply.products];
    products[index].buttons[btn_index].title = e.target.value;
    props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, products: products } });
  };

  const handleProductBtnURLChange = (e, index, btn_index) => {
    const products = [...props.state.auto_reply.products];
    products[index].buttons[btn_index].url = e.target.value;
    props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, products: products } });
  };

  const onProductButtonRemove = (index, btn_index) => {
    const products = [...props.state.auto_reply.products];

    // if (products[index].buttons.length <= 1) {
    //   messageApi.error("one link is must.")
    //   return;
    // }

    products[index].buttons.splice(btn_index, 1);
    props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, products: products } });
  };


  const handleBtnNameChange = (e, index) => {
    const btns = [...props.state.auto_reply.buttons];
    btns[index].title = e.target.value;
    props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, buttons: btns } });
  };


  const handlePaymentButtonChange = (e) => {
    
    props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, payment_details:{...props.state.auto_reply.payment_details, button_text:e.target.value}}})
  };
    
  

  const handleFollowBtnNameChange = (e) => {
    props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, ask_follow: { ...props.state.auto_reply.ask_follow, button_text: e.target.value } } });
  };

  const handleFollowBtnProfileOpenChange = (e) => {
    props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, ask_follow: { ...props.state.auto_reply.ask_follow, open_profile_text: e.target.value } } });
  };


  const handleWelcomeBtnNameChange = (e) => {
    props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, welcome_message: { ...props.state.auto_reply.welcome_message, button_text: e.target.value } } });
  };



  const handleBtnURLChange = (e, index) => {
    const btns = [...props.state.auto_reply.buttons];
    btns[index].url = e.target.value;
    props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, buttons: btns } });
  };



  const onRemove = (index) => {
    let btns = props.state.auto_reply.buttons || [];

    if (btns.length < index) {
      return;
    }
    btns.splice(index, 1);
    props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, buttons: btns } });
  };





  return (
    <div style={{display:"flex", width:"100%" , flexDirection:"row", maxHeight:"100vh", overflowX:"scroll"}}>
      {contextHolder}
      <div className="desktop" style={{flex:"1"}}>
        <CommentPreview igData={props.igData} data = {props.state} />
        
      </div>
       
    <div style={{marginRight:"20px" , maxHeight:"100vh", overflowX:"scroll"}} className="drawer-item">

      
      {
        props.isNextPostReply && <Alert
          message="Next Post Automation"
          description="Create your configuration before you upload your post."
          type="info"
          showIcon
        />
      }
      {/* {( !props.isNextPostReply && props.state.auto_reply.enable == false) && <Alert
        message="Not Active"
        description="Your automation is not active. Don't worry we have saved your last automation configuration. To reactivate just click the publish button on top right cornor"
        type="warning"
        showIcon
      />
      } */}
      {/* {
          ( !props.isNextPostReply && localStorage.getItem("ig_api") != "true" ) &&
             <div className="connect-ig-feature">
              <p>We have added new features, that requires you to connect your IG account, Please reconnect your IG account.</p>
              <a href="/ig-connect?show_ig_connect=true">Re-connect your IG</a>
             </div>
        } */}

      {(localStorage.getItem("previous_config") != undefined && !props.isDMAuto) &&
        <div className="action-box">
          <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between', alignItems: 'center', alignItems: 'center' }}>
            <h4>
              <CopyOutlined className="icon follow" /> Copy Automation from previous post! <CrownReturn premiumUser={AccessOrNot("copy_previous_post")} />
            </h4>
            <Switch disabled={!AccessOrNot("copy_previous_post")} style={{ marginTop: '20px' }} onChange={(value) => {
              setPrevStateCopy(value)
            }} defaultValue={prevState} />
          </div>
        </div>
      }
      <div className="action-box">
        <h4>
          <ThunderboltOutlined className="icon thunder" /> {props.isDMAuto ? `Trigger : When an audience DM'ed you with specific word` : (props.isStory) ? ` Trigger : When audience replied to story` : ` Trigger : When audience commented "link / blog"`}
        </h4>
        <p>{props.isDMAuto ? "" : props.isStory ? "You can automate all DMs or add specific words." : "You can automate all comments or add specific tirgger words."}</p>
        <div className="flex-divider">
          {!props.isDMAuto &&
            <Radio.Group onChange={(e) => { props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, automate_all: e.target.value } }) }} value={props.state.auto_reply.automate_all || "false"}>
              <Radio.Button value="false">{props.isStory ? "Specific DM Word" : "Specific Comments"}</Radio.Button>
              <Radio.Button value="true" disabled={!AccessOrNot("all_comment")}>{props.isStory ? "All DM for this story" : "All comments"} <CrownReturn premiumUser={AccessOrNot("all_comment")} /> </Radio.Button>
            </Radio.Group>
          }

          {props.state.auto_reply.automate_all != "true" ?
            isAddingTag && addingType === 'tag' ? (
              <Input
                placeholder="Expected Word"
                ref={inputRef}
                type="text"
                size="large"
                style={{ width: '200px' }}
                value={inputValue}
                onChange={handleInputChange}
                onBlur={handleInputConfirm}
                onPressEnter={handleInputConfirm}
              />
            ) : (
              <>
               { !AccessOrNot("trigger_words" , true,  props?.state?.auto_reply?.triger_words?.length )  ? <Tag className="add-new-tag" onClick={() => showInput('tag')}>
                  <PlusOutlined /> Expected Word
                </Tag> : <Tag  className="add-new-tag" color="red" >Trigger word Limit reached. <CrownReturn premiumUser={false} /> </Tag>

            }
              </>
            )
            : <p>{(props.isStory || props.isDMAuto) ? "All DM will be automated" : "All comments will be automated."}</p>

          }
         
          {props.state.auto_reply.automate_all != "true" && <div>{tagChild}</div>}

          {!props.isDMAuto && <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between', alignItems: 'center', alignItems: 'center' }}>
            <h4>
              Automate Post sent to your DM  <CrownReturn premiumUser={AccessOrNot("post_dm")} />
            </h4>
            <Switch disabled={!AccessOrNot("post_dm")} style={{ marginTop: '20px' }} onChange={(value) => { props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, dm_shared_reply: value } }) }} value={["true", true].includes(props.state.auto_reply.dm_shared_reply) ? true : false} />
          </div>}

          {
            (localStorage.getItem("ig_api") != "true" && ["true", true].includes(props.state.auto_reply.dm_shared_reply)) &&
            <div className="connect-ig-feature">
              <p>To use this Post sent to your DM feature please reconnect your IG account.</p>
              <a href="/ig-connect?show_ig_connect=true">Re-connect your IG</a>
            </div>
          }

        </div>

      </div>

      {
        (!props.isDMAuto && !props.isStory) && <div className="action-box">
          {(props.state.auto_reply?.followers_only && props.state.auto_reply.enable_comment_reply) && <Tag color="blue" style={{ fontWeight: '500', fontSize: '12px' }}>Replies to every comment.</Tag>}
          <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between', alignItems: 'center', alignItems: 'center' }}>

            <h4>
              <CommentOutlined className="icon reply" /> Reply with comment!
            </h4>

            <Switch style={{ marginTop: '20px' }} onChange={(value) => { props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, enable_comment_reply: value } }) }} value={props.state.auto_reply.enable_comment_reply != undefined ? props.state.auto_reply.enable_comment_reply : true} />

          </div>

          {props.state.auto_reply.enable_comment_reply == false ? <div> <p>You have turned off this.</p> </div> :

            <div>

              <p>Reply to your audience comments with a custom response.</p>

              <div className="flex-divider">


                {isAddingTag && addingType === 'comment' ? (
                  <Input
                    placeholder="Reply Comment"
                    ref={commentRef}
                    type="text"
                    size="large"
                    style={{ width: '300px' }}
                    value={commentValue}
                    onChange={handleInputChange}
                    onBlur={handleInputConfirm}
                    onPressEnter={handleInputConfirm}
                  />
                ) : 
                !AccessOrNot("reply_comments" , true,  props?.state?.auto_reply?.reply_comments?.length ) ? <Tag style={{ width: '300px' }} className="add-new-tag" onClick={() => showInput('comment')}>
                    <PlusOutlined /> Reply Comment
                  </Tag> : <Tag  className="add-new-tag" color="red" >Reply Limit reached. <CrownReturn premiumUser={false} /> </Tag>
                  
                }


                <div style={{ overflow: 'scroll' }}>{commentChild}</div>
                <div style={{ display: 'flex', flexDirection: "row", gap:"10px", alignItems: 'center', alignItems: 'center' }}>

                  <Checkbox disabled={!AccessOrNot("ai_reply_comments" )} onChange={(e) => { props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, include_ai_comment_reply: e.target.checked } }) }} checked={props.state.auto_reply.include_ai_comment_reply != undefined ? props.state.auto_reply.include_ai_comment_reply : false} > Also Include AI Comment Reply (to prevent comment spam)</Checkbox>
                  <CrownReturn premiumUser={AccessOrNot("ai_reply_comments")} />
                </div>
              </div>

            </div>
          }
        </div>
      }


      {/* { !props.isStory && <div className="action-box">
         <h4><ThunderboltOutlined className="icon thunder" /> Trigger 2 :  Post sent to your DM <TempFree/> <Beta/> </h4>
        <p>If your audience DM's you this post, We'll automate the message if configured.</p>

          <Radio.Group disabled={localStorage.getItem("ig_api") != "true" ? true : false} onChange={(e) => { props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, dm_shared_reply: e.target.value } }) }} defaultValue={props.state.auto_reply.dm_shared_reply}>
            <Radio.Button value="true">Automate</Radio.Button>
            <Radio.Button value="false">Don't Automate</Radio.Button>
          </Radio.Group>

          {
           localStorage.getItem("ig_api") != "true" &&
             <div className="connect-ig-feature">
              <p>To use this feature please reconnect your IG account.</p>
              <a href="/ig-connect?show_ig_connect=true">Re-connect your IG</a>
             </div>
        }
          {props.state.auto_reply.dm_shared_reply == "true" && <p>We'll automate this post that sent to your DM.</p>}
          </div>
          } */}

      {/*Welcome message  */}
      {!props.isDMAuto &&
        <div className="action-box">
          <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between', alignItems: 'center', alignItems: 'center' }}>
            <h4>
              <UserSwitchOutlined className="icon follow" /> Welcome Message <CrownReturn premiumUser={AccessOrNot("welcome_message")} />
            </h4>
            <Switch disabled={!AccessOrNot("welcome_message")} style={{ marginTop: '20px' }} onChange={(value) => { props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, welcome_message: { ...props.state.auto_reply.welcome_message, enabled: value } } }) }} value={props.state.auto_reply?.welcome_message?.enabled || false} />
          </div>
          <div> <p>This is the first message a audience sees when they comment on your post, this should not contain any link.</p> </div>

          {props.state.auto_reply?.welcome_message?.enabled == true && <div className="btn-tmp-bldr">

            <div style={{ marginTop: '40px', padding: '20px' }} >


              <EditTextarea style={{ width: '90%', padding: '10px', fontSize: '14px' }}
                onSave={(e) =>
                  props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, welcome_message: { ...props.state.auto_reply.welcome_message, text: e.value } } })
                }
                inline={true} rows={3} defaultValue={props.state.auto_reply?.welcome_message?.text || "Hey, here is the content you have commented for, click below to get your content."} />

              <div className="msg-btn" style={{ paddingBottom: '10px' }}>
                <Collapse
                  destroyInactivePanel={true}
                  style={{ textAlign: 'center', backgroundColor: 'white' }}
                  items={[
                    {
                      key: '1',
                      label: props.state.auto_reply?.welcome_message?.button_text || "Get my content",
                      children: (
                        <div className="edit-input">
                          <Input
                            style={{ marginBottom: '20px' }}
                            placeholder="Get my content"
                            onChange={(e) => { handleWelcomeBtnNameChange(e) }}
                            value={props.state.auto_reply?.welcome_message?.button_text || "Get my content"}
                          />

                        </div>
                      ),
                      showArrow: false,
                    },
                  ]}
                />
              </div>
            </div>

          </div>
          }
          {
            (props.state.auto_reply?.welcome_message?.enabled == true && localStorage.getItem("ig_api") != "true") &&
            <div className="connect-ig-feature">
              <p>To use this feature please reconnect your IG account.</p>
              <a href="/ig-connect?show_ig_connect=true">Re-connect your IG</a>
            </div>
          }

        </div>

      }
      <div className="action-box">

        {localStorage.getItem("ig_api") == "true" ? <> <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between', alignItems: 'center', alignItems: 'center' }}>
          <h4>
            <UserAddOutlined className="icon follow" /> {props.isDMAuto ? "Ask audience to follow you before sending reply" : "Ask audience to follow you before sending link!"} <CrownReturn premiumUser={AccessOrNot("follow_only")} />
          </h4>
          <Switch disabled={!AccessOrNot("follow_only")} style={{ marginTop: '20px' }} onChange={(value) => { props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, followers_only: value } }) }} value={props.state.auto_reply?.followers_only || false} />
        </div>
          <div> <p>We'll ask your audience to follow you, before sharing the exclusive content or replying.</p> </div>
        </> :
          <>
            <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between', alignItems: 'center', alignItems: 'center' }}>
              <h4>
                <UserAddOutlined className="icon follow" /> Send only to followers! <TempFree /> <Beta />
              </h4>
              <Switch style={{ marginTop: '20px' }} onChange={(value) => { props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, followers_only: value } }) }} value={props.state.auto_reply?.followers_only || false} />
            </div>
            <div> <p>We'll ask your audience to follow you, before sharing the exclusive content.</p> </div>
          </>
        }

        {
          (localStorage.getItem("ig_api") != "true" && props.state.auto_reply?.followers_only == true) &&
          <div className="connect-ig-feature">
            <p>To use this feature please reconnect your IG account.</p>
            <a href="/ig-connect?show_ig_connect=true">Re-connect your IG</a>
          </div>
        }
        {
          (localStorage.getItem("ig_api") == "true" && props.state.auto_reply?.followers_only) && <>
            <Tag color="purple" style={{ fontWeight: '500', fontSize: '12px' }}>Will send this only to non-followers.</Tag>
            <div className="btn-tmp-bldr">

              <div style={{ marginTop: '40px', padding: '20px' }} >

                 <EditTextarea style={{ width: '90%', padding: '10px', fontWeight: 'bold', maxWidth: '100%', display: 'inline-block !important' }}
                  inline={true} onSave={(e) =>

                    props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, ask_follow: { ...props.state.auto_reply.ask_follow, title: e.value } } })
                  } defaultValue={props.state.auto_reply?.ask_follow?.title || "🔓 Follow to Unlock Exclusive Content"} />

                <EditTextarea style={{ width: '90%', padding: '10px', fontSize: '14px' }}
                  onSave={(e) =>
                    props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, ask_follow: { ...props.state.auto_reply.ask_follow, description: e.value } } })
                  }
                  inline={true} rows={2} defaultValue={props.state.auto_reply?.ask_follow?.description || "👋 Looks like you haven't followed me yet! 🤔 Follow to unlock exclusive content! 🔓"} />

                <div className="msg-btn" style={{ paddingBottom: '10px' }}>
                  <Collapse
                    destroyInactivePanel={true}
                    style={{ textAlign: 'center', backgroundColor: 'white' }}
                    items={[
                      {
                        key: '2',
                        label: props.state.auto_reply?.ask_follow?.open_profile_text || "Open Profile",
                        children: (
                          <div className="edit-input">
                            <Input
                              style={{ marginBottom: '20px' }}
                              placeholder="I'm a follower"
                              onChange={(e) => { handleFollowBtnProfileOpenChange(e) }}
                              value={props.state.auto_reply?.ask_follow?.open_profile_text || "Open Profile"}
                            />

                          </div>
                        ),
                        showArrow: false,
                      },
                      {
                        key: '1',
                        label: props.state.auto_reply?.ask_follow?.button_text || "Started following you! 👍",
                        children: (
                          <div className="edit-input">
                            <Input
                              style={{ marginBottom: '20px' }}
                              placeholder="I'm a follower"
                              onChange={(e) => { handleFollowBtnNameChange(e) }}
                              value={props.state.auto_reply?.ask_follow?.button_text || "Started following you! 👍"}
                            />

                          </div>
                        ),
                        showArrow: false,
                      },
                    ]}
                  />
                </div>
              </div>

            </div>
            <p style={{ opacity: '30', textAlign: 'center' }}>When the commenting / DM'ing user doesn't follow you, the above template will be sent in a DM. You can customize this template, by taping over the text.</p>
          </>
        }



      </div>


      {/* <div className="action-box">

      
        <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between', alignItems: 'center', alignItems: 'center' }}>
          <h4>
            <BsCashCoin  className="icon money" /> Collect Money from audience <Beta/>
          </h4>
          
          <Switch style={{ marginTop: '20px' }} onChange={(value) => { props.setData(
            { ...props.state, auto_reply: { ...props.state.auto_reply, collect_money: value  ,  welcome_message: { ...props.state.auto_reply.welcome_message, enabled: value == true ? true : (props.state.auto_reply.welcome_message.enabled || false ) }
           }}
            ) }} value={props.state.auto_reply?.collect_money || false} />
        </div>
      <div> <p>You can collect money from your audience for digital products, T-Shirts, Dress, events, webinars and more (only for legal usage).</p></div>       

        {
        props.state.auto_reply?.collect_money &&  <>

          <h3>Product or Event Details </h3>
          <Input onChange={(e) => { props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, payment_details: {...props.state.auto_reply.payment_details,product_title:e.target.value } } }) }} value={props.state.auto_reply?.payment_details?.product_title}  style={{marginBottom:"20px"}} placeholder="Product Name ? Whare are you selling" block/>
          <Input.TextArea rows={8} onChange={(e) => { props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, payment_details: {...props.state.auto_reply.payment_details,product_description:e.target.value } } }) }} value={props.state.auto_reply?.payment_details?.product_description}  style={{marginBottom:"20px"}} placeholder="Product Description ? Tell your audience what your selling" block/>

          <div className="price" style={{display:"flex", flexDirection:"row", flexWrap:"wrap", gap:'20px'}}>
            <Select onChange={(value) => { props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, payment_details: {...props.state.auto_reply.payment_details,currency:value } } }) }} value={props.state.auto_reply?.payment_details?.currency || "USD"} style={{width:"45%"}} options={supported_currency} />
            <Input  onChange={(e) => { props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, payment_details: {...props.state.auto_reply.payment_details,r_price:e.target.value } } }) }} value={props.state.auto_reply?.payment_details?.r_price}  style={{width:"45%"}} placeholder="Regular Price (Min : 1)" />
            <Input prefix={<TagTwoTone/>} onChange={(e) => { props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, payment_details: {...props.state.auto_reply.payment_details,o_price:e.target.value } } }) }} value={props.state.auto_reply?.payment_details?.o_price }  style={{width:"45%"}} placeholder="Offer Price (Optional)" />
            <Input prefix={<AppleFilled/>} onChange={(e) => { props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, payment_details: {...props.state.auto_reply.payment_details,a_price:e.target.value } } }) }} value={props.state.auto_reply?.payment_details?.a_price}  style={{width:"45%"}} placeholder="Apple Offer Price (Optional)" />
          </div>
            
            <h3>Message to audience</h3>
            <p style={{ textAlign: 'left' }}>You can customize the message.</p>
            <div className="btn-tmp-bldr">

              <div style={{ marginTop: '40px', padding: '20px' }} >

                 <EditTextarea style={{ width: '90%', padding: '10px', fontWeight: 'bold', maxWidth: '100%', display: 'inline-block !important' }}
                  inline={true} onSave={(e) =>

                    props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, payment_details: { ...props.state.auto_reply.payment_details, message_title: e.value } } })
                  } defaultValue={props.state.auto_reply?.payment_details?.message_title || "✨ Pay to Access Premium Content"} />

                <EditTextarea style={{ width: '90%', padding: '10px', fontSize: '14px' }}
                  onSave={(e) =>
                    props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, payment_details: { ...props.state.auto_reply.payment_details, message_description: e.value } } })
                  }
                  inline={true} rows={2} defaultValue={props.state.auto_reply?.payment_details?.message_description || "💰 Unlock premium content now! Pay a small fee for exclusive access! 🚀"} />

                <div className="msg-btn" style={{ paddingBottom: '10px' }}>
                  <Collapse
                    destroyInactivePanel={true}
                    style={{ textAlign: 'center', backgroundColor: 'white' }}
                    items={[
                      {
                        key: '1',
                        label: props.state.auto_reply?.payment_details?.button_text || "💳 Buy Now",
                        children: (
                          <div className="edit-input">
                            <Input
                              style={{ marginBottom: '20px' }}
                              placeholder="I'm a follower"
                              onChange={(e) => { handlePaymentButtonChange(e) }}
                              value={props.state.auto_reply?.payment_details?.button_text ||  "💳 Buy Now"}
                            />

                          </div>
                        ),
                        showArrow: false,
                      },
                    ]}
                  />
                </div>
              </div>

            </div>
            <p style={{ opacity: '30', textAlign: 'left' }}>InstantDM will charge a small commission along with payment gateway fees. The remaining amount will be transferred to your bank account after proper communication.</p>
          </>
        }



      </div> */}

      <DMTypeCards state={props.state} setData={(data) => {
        props.setData({
        
          ...data
        })
      }} />

      {/* <Radio.Group
        value={props.state.auto_reply.dm_reply_type || "single"}
        style={{marginBottom:"20px"}}
        onChange={(e) => {
 
          props.setData({
            ...props.state,
            auto_reply: { ...props.state.auto_reply, dm_reply_type:e.target.value }
          });
        }}
      >
        <Radio.Button value="single">Single Message</Radio.Button>
        <Radio.Button value="sequence">DM sequence</Radio.Button>

      </Radio.Group> */}
    
    { props.state.auto_reply.dm_reply_type != "sequence" &&  <div className="action-box">
        {(props.state.auto_reply?.followers_only && props.state.auto_reply.enable_dm_reply) && <Tag color="green" style={{ fontWeight: '500', fontSize: '12px' }}>Will send this only to followers.</Tag>}
        <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between', alignItems: 'center', alignItems: 'center' }}>
          <h4>
            <SendOutlined className="icon direct" /> {props.isDMAuto ? "Send a reply" : "Send a DM!"}
          </h4>
          <Switch style={{ marginTop: '20px' }} onChange={(value) => { props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, enable_dm_reply: value } }) }} value={props.state.auto_reply.enable_dm_reply != undefined ? props.state.auto_reply.enable_dm_reply : true} />
        </div>
        {props.state.auto_reply.enable_dm_reply == false ? <div> <p>You have turned off this. </p> </div> :
          <div disabled>
            <p>Send a direct message to your audience, such as links, coupons or other custom messages.</p>

            <Radio.Group style={{ "marginBottom": "20px" }} onChange={(e) => {
              let products = props.state.auto_reply.products || [{
                "title": "",
                "subtitle": "",
                "buttons": [{ "title": "click to edit", "url": "", type: "web_url" }],
                "thumnailURL": undefined

              }]
              props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, products: products, dm_template_type: e.target.value } })
            }}
              value={props.state.auto_reply.dm_template_type || "text"}>
              <Radio.Button value="text">Text</Radio.Button>
              <Radio.Button disabled={!AccessOrNot("button_template")} value="button">Button <CrownReturn premiumUser={AccessOrNot("button_template")} /> </Radio.Button>
              <Radio.Button disabled={!AccessOrNot("button_template")} value="products">Products <CrownReturn premiumUser={AccessOrNot("button_template")} /> </Radio.Button>
            </Radio.Group>

            {/* {
              props.state.auto_reply.dm_template_type == "text" && <TextArea rows={6} value={props.state.auto_reply.dms.length > 0 ?
                props.state.auto_reply.dms[0] : ''} onChange={(e) =>
                  props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, dms: [e.target.value] } })}
                placeholder="Enter message here..." maxLength={1000} showCount />
            } */}

            {
              props.state.auto_reply.dm_template_type == "button" &&

              <>

                <div className="btn-tmp-bldr">


                  {props.state.auto_reply.cover_image && <div className="img-box">
                    <img style={{ maxWidth: '100%', maxHeight: '200px', borderRadius: 'inherit', objectFit: 'cover', width: '100%' }} src={props.state.auto_reply.cover_image} />
                  </div>
                  }


                  <div style={props.state.auto_reply.cover_image == undefined ? { marginTop: '40px', padding: '20px' } : { marginTop: '10px', padding: '10px' }} >

                    <EditTextarea style={{ width: '90%', overflow:"hidden", padding: '10px', fontWeight: 'bold', maxWidth: '100%', display: 'block !important' }}
                      rows={1}
                      inline={true} onSave={(e) =>
                        // console.log("==============e" , e)
                        props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, title: e.value } })
                      } defaultValue={props.state.auto_reply.title || "Click to edit title"} />

                    <EditTextarea style={{ width: '90%', padding: '10px', fontSize: '12px' }}
                      onSave={(e) =>
                        props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, subtitle: e.value } })
                      }
                      inline={true} rows={1} defaultValue={props.state.auto_reply.subtitle || "Click to edit description"} />

                    {
                      props.state.auto_reply.buttons.map((item, index) =>

                        <div className="msg-btn" style={{ paddingBottom: '10px' }}>
                          <Collapse
                            style={{ textAlign: 'center', backgroundColor: 'white' }}
                            items={[
                              {
                                key: '1',
                                label: item.title,
                                children: (
                                  <div className="edit-input">
                                    <Input
                                      prefix={'T'}
                                      style={{ marginBottom: '20px' }}
                                      placeholder="Button Text"
                                      onChange={(e) => { handleBtnNameChange(e, index) }}
                                      value={item.title}
                                    />
                                    <Input
                                      prefix={<GlobalOutlined />}
                                      style={{ marginBottom: '10px' }}
                                      placeholder="Button URL"
                                      onChange={(e) => { handleBtnURLChange(e, index) }}
                                      value={item.url}
                                    />
                                    <Button danger block onClick={() => onRemove(index)}>
                                      Remove Button
                                    </Button>
                                  </div>
                                ),
                                showArrow: false,
                              },
                            ]}
                          />
                        </div>

                      )
                    }

                    <div className="">

                    </div>
                  </div>
                </div>
                

                  {props.state.auto_reply.buttons.length < 3 &&
                  
                  <Button
                    disabled={AccessOrNot("button_template" , true,  props.state.auto_reply.buttons.length)}
                    onClick={() => {
                      props.setData({
                        ...props.state,
                        auto_reply: {
                          ...props.state.auto_reply, buttons: [...props.state.auto_reply.buttons,
                          { "title": "click to edit", "url": "", type: "web_url" }]
                        }
                      })
                    }} block style={{ height: '40px', margin: 'auto', marginTop: '20px', }}>Add more button</Button>

                }
                {
                  (AccessOrNot("button_template" , true,  props.state.auto_reply.buttons.length) && props.state.auto_reply.buttons.length < 3 ) && <Tag style={{ marginTop:"20px"}} color="red" >Button Limit reached. Upgrade your plan <CrownReturn limit_reached={true} /> </Tag>
                }

                <Upload
                  action=""
                  accept="image/png"
                  beforeUpload={() => { return false }}
                  listType="picture"
                  defaultFileList={props.state.auto_reply.cover_image ? [{ "name": "cover_image.jpg", 'uid': 1, "thumbUrl": props.state.auto_reply.cover_image, "url": props.state.auto_reply.cover_image, "status": "done" }] : []}
                  onChange={({ file, fileList }) => (handleImageUpload(file, props.state.post_id))}
                  maxCount={1}
                >
                  {thumnailURL == undefined && <Button type="primary" style={{ marginTop: '20px' }} icon={<UploadOutlined />} block>
                    Upload Cover image
                  </Button>

                  }
                </Upload>
              </>
            }


            {
              (props.state.auto_reply.dm_template_type == "text" || props.state.auto_reply.dm_template_type == undefined) && <TextArea rows={6} value={props.state.auto_reply.dms.length > 0 ?
                props.state.auto_reply.dms[0] : ''} onChange={(e) =>
                  props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, dms: [e.target.value] } })}
                placeholder="Enter message here..." maxLength={1000} showCount />
            }

            {
              props.state.auto_reply.dm_template_type == "products" &&
              <>
                {(props.state.auto_reply.products || []).length <= 10 ? <div>

                  <Button onClick={() => {
                    let products = props.state.auto_reply.products || [];
                    products.push(
                      {
                        "title": "",
                        "subtitle": "",
                        "buttons": [{ "title": "click to edit", "url": "", type: "web_url" }],
                        "cover_image": undefined

                      }
                    )
                    props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, products: products } })
                  }
                  } type="default">Add product</Button>
                  <p>You can add upto 10 products with 3 links each, you can send 30 links.</p>
                  <p><TempFree /> When you want to send multiple pictures of the product or share multiple product list, you can use products.</p>
                </div>
                  : <div>
                    <p>You have reached max limit of products</p>
                  </div>
                }


                <div className="products-list">
                  {
                    props.state.auto_reply.products.map((item, index) =>


                      <div className="product-item">
                        <div className="btn-tmp-bldr">


                          {item.image_url && <div className="img-box">
                            <img style={{ maxWidth: '100%', maxHeight: '200px', borderRadius: 'inherit', objectFit: 'cover', width: '100%' }} src={item.image_url} />
                          </div>
                          }


                          <div style={props.state.auto_reply.cover_image == undefined ? { marginTop: '40px', padding: '20px' } : { marginTop: '10px', padding: '10px' }} >

                             <EditTextarea style={{ width: '90%', padding: '10px', fontWeight: 'bold', maxWidth: '100%', display: 'inline-block !important' }}
                              inline={true} onSave={(e) => {
                                // console.log("==============e" , e)

                                let products = props.state.auto_reply.products
                                products[index].title = e.value

                                props.setData({
                                  ...props.state, auto_reply: {
                                    ...props.state.auto_reply, products: products
                                  }
                                })
                              }

                              } defaultValue={item.title || "Click to edit title"} />

                            <EditTextarea style={{ width: '90%', padding: '10px', fontSize: '12px' }}
                              onSave={(e) => {
                                let products = props.state.auto_reply.products
                                products[index].subtitle = e.value

                                props.setData({
                                  ...props.state, auto_reply: {
                                    ...props.state.auto_reply, products: products
                                  }
                                })
                              }

                              }
                              inline={true} rows={1} defaultValue={props.state.auto_reply.subtitle || "Click to edit description"} />

                            {
                              item.buttons.map((btn_item, btn_index) =>

                                <div className="msg-btn" style={{ paddingBottom: '10px' }}>
                                  <Collapse
                                    style={{ textAlign: 'center', backgroundColor: 'white' }}
                                    items={[
                                      {
                                        key: '1',
                                        label: btn_item.title,
                                        children: (
                                          <div className="edit-input">
                                            <Input
                                              prefix={'T'}
                                              style={{ marginBottom: '20px' }}
                                              placeholder="Button Text"
                                              onChange={(e) => { handleProductBtnNameChange(e, index, btn_index) }}
                                              value={btn_item.title}
                                            />
                                            <Input
                                              prefix={<GlobalOutlined />}
                                              style={{ marginBottom: '10px' }}
                                              placeholder="Button URL"
                                              onChange={(e) => { handleProductBtnURLChange(e, index, btn_index) }}
                                              value={btn_item.url}
                                            />
                                            <Button danger block onClick={() => onProductButtonRemove(index, btn_index)}>
                                              Remove Button
                                            </Button>
                                          </div>
                                        ),
                                        showArrow: false,
                                      },
                                    ]}
                                  />
                                </div>

                              )
                            }

                            <div className="">

                            </div>
                          </div>
                        </div>

                        <div className="btn-temp-conf">


                          {
                            item.buttons.length < 3 &&
                            <Button
                              block
                              onClick={() => {

                                let products = props.state.auto_reply.products
                                products[index].buttons = [...item.buttons,
                                { "title": "click to edit", "url": "", type: "web_url" }]

                                props.setData({
                                  ...props.state, auto_reply: {
                                    ...props.state.auto_reply, products: products
                                  }
                                })

                                // props.setData({
                                //   ...props.state,
                                //   auto_reply: {
                                //     ...props.state.auto_reply, buttons: [...props.state.auto_reply.buttons,
                                //     { "title": "click to edit", "url": "", type: "web_url" }]
                                //   }
                                // })
                              }} style={{ margin: 'auto', marginTop: '20px' }}><PlusSquareOutlined /> Link</Button>
                          }

                          <Upload
                            action=""
                            accept="image/png"
                            beforeUpload={() => { return false }}
                            listType="picture"
                            defaultFileList={item.image_url ? [{ "name": "cover_image.jpg", 'uid': 1, "thumbUrl": item.image_url, "url": item.image_url, "status": "done" }] : []}
                            onChange={({ file, fileList }) => (handleProductImageUpload(file, index))}
                            maxCount={1}
                          >
                            {<Button block type="primary" style={{ marginTop: '20px' }} icon={<UploadOutlined />}>
                              Image
                            </Button>

                            }
                          </Upload>

                          <Popconfirm
                            title="Delete this product?"
                            description="Are you sure to delete this product?"
                            okText="Yes, Delete"
                            cancelText="No, Ignore"
                            placement='left'
                            onConfirm={() => {
                              let products = props.state.auto_reply.products
                              if (products.length <= 1) {
                                messageApi.error("Atleast one product should be there.")
                                return
                              }
                              products.splice(index, 1)

                              props.setData({
                                ...props.state, auto_reply: {
                                  ...props.state.auto_reply, products: products
                                }
                              })
                            }}
                          >
                            <Button
                              type="primary"
                              danger
                              onClick={() => {
                                props.setData({
                                  ...props.state,
                                  auto_reply: {
                                    ...props.state.auto_reply, buttons: [...props.state.auto_reply.buttons,
                                    { "title": "click to edit", "url": "", type: "web_url" }]
                                  }
                                })
                              }} style={{ margin: 'auto', marginTop: '20px', }} block><DeleteOutlined /> Delete</Button>
                          </Popconfirm>




                        </div>
                      </div>

                    )}



                </div>


              </>
            }



          </div>

        }
      </div> }

      { props.state.auto_reply.dm_reply_type == "sequence" &&  <div className="action-box">
        {(props.state.auto_reply?.followers_only && props.state.auto_reply.enable_dm_reply) && <Tag color="green" style={{ fontWeight: '500', fontSize: '12px' }}>Will send this only to followers.</Tag>}

        <div style={{ display: "flex", justifyContent: "space-between" , marginBottom:"10px"}}>
          
          <h4><SendOutlined /> Send DM Sequence</h4>
          <Switch
            checked={props.state.auto_reply.enable_dm_reply}
            onChange={(value) =>
              props.setData({
                ...props.state,
                auto_reply: { ...props.state.auto_reply, enable_dm_reply: value }
              })
            }
          />
        </div>

        {!props.state.auto_reply.enable_dm_reply ? (
          <p>You have turned this off.</p>
        ) : (
          <>
            {(props.state.auto_reply.messages || []).map((msg, index) => (
              <Card
                key={index}
                title={`Message ${index + 1}`}
                extra={
                  <Popconfirm
                    title="Delete this message?"
                    onConfirm={() => {
                      let messages = [...props.state.auto_reply.messages];
                      messages.splice(index, 1);
                      props.setData({
                        ...props.state,
                        auto_reply: { ...props.state.auto_reply, messages }
                      });
                    }}
                  >
                    <Button danger size="small">Delete</Button>
                  </Popconfirm>
                }
                style={{ marginBottom: "15px" }}
              >
                {/* Delay Option */}
                { index >= 1 && <div style={{ marginBottom: "10px" }}>
                  <span>Delay (minutes): </span>
                  <InputNumber
                    min={0}
                    value={msg.delay}
                    onChange={(val) => {
                      let messages = [...props.state.auto_reply.messages];
                      messages[index].delay = val;
                      props.setData({
                        ...props.state,
                        auto_reply: { ...props.state.auto_reply, messages }
                      });
                    }}
                  />
                </div> }

                {/* Template Type Selector */}
                <Radio.Group
                  value={msg.type}
                  style={{marginBottom:"20px"}}
                  onChange={(e) => {
                    let messages = [...props.state.auto_reply.messages];
                    messages[index].type = e.target.value;
                    props.setData({
                      ...props.state,
                      auto_reply: { ...props.state.auto_reply, messages }
                    });
                  }}
                >
                  <Radio.Button value="text">Text</Radio.Button>
                  <Radio.Button value="button">Button</Radio.Button>
                  <Radio.Button value="image">Image</Radio.Button>

                  <Radio.Button value="audio">Audio</Radio.Button>

                </Radio.Group>

                {/* Render Editor based on type */}

                {msg.type === "image" && (

                  <div>
                  { msg?.image_url && <Image src={msg?.image_url}/> }

                    <Upload
                      action=""
                      accept="image/*"
                      beforeUpload={() => false}
                      listType="picture"
                      defaultFileList={
                        msg?.image_url
                          ? [
                              {
                                name: uuidv4() + ".jpg",
                                uid: uuidv4(),
                                thumbUrl: msg?.image_url,
                                url: msg?.image_url,
                                status: "done",
                              },
                            ]
                          : []
                      }
                      onChange={({ file }) => handleImageUpload(file, (url) => {
                        
                    let messages = [...props.state.auto_reply.messages];
                    messages[index].image_url = url;
                    props.setData({
                      ...props.state,
                      auto_reply: { ...props.state.auto_reply, messages }
                    });

                      })}
                      maxCount={1}
                    >
                      
                        <Button
                          type="default"
                          variant="outlined"
                          style={{ marginTop: "20px" }}
                          icon={<UploadOutlined />}
                          block
                        >
                          Upload image
                        </Button>
                      
                    </Upload>
                  </div>
                )}

                {msg.type === "audio" && (

                  <div>
                  { msg?.audio_url &&  <audio controls src={msg?.audio_url}>
                  Your browser does not support the audio element.
                </audio> }

                    <Upload
                      action=""
                      accept="audio/*"
                      beforeUpload={() => false}
                      listType="picture"
                      defaultFileList={
                        msg?.audio_url
                          ? [
                              {
                                name: uuidv4() ,
                                uid: uuidv4(),
                                thumbUrl: msg?.audio_url,
                                url: msg?.audio_url,
                                status: "done",
                              },
                            ]
                          : []
                      }
                      onChange={({ file }) => handleImageUpload(file, (url) => {
                        
                    let messages = [...props.state.auto_reply.messages];
                    messages[index].audio_url = url;
                    props.setData({
                      ...props.state,
                      auto_reply: { ...props.state.auto_reply, messages }
                    });

                      })}
                      maxCount={1}
                    >
                      
                        <Button
                          type="default"
                          variant="outlined"
                          style={{ marginTop: "20px" }}
                          icon={<UploadOutlined />}
                          block
                        >
                          Upload Audio
                        </Button>
                      
                    </Upload>
                  </div>
                )}

                {msg.type === "text" && (
                  <TextArea
                    rows={4}
                    value={msg.dms?.[0] || ""}
                    onChange={(e) => {
                      let messages = [...props.state.auto_reply.messages];
                      messages[index].dms = [e.target.value];
                      props.setData({
                        ...props.state,
                        auto_reply: { ...props.state.auto_reply, messages }
                      });
                    }}
                    placeholder="Enter message..."
                    maxLength={1000}
                    showCount
                  />
                )}

                {msg.type === "button" && (
                  <ButtonTemplateComp  handleImageUpload={handleImageUpload} data={msg} onChange={ (message) => {

                    let messages = [...props.state.auto_reply.messages];
                      messages[index] = message;
                      props.setData({
                        ...props.state,
                        auto_reply: { ...props.state.auto_reply, messages }
                      });

                  }} onRemove={onRemove} handleBtnURLChange={handleBtnURLChange} handleBtnNameChange={handleBtnNameChange} AccessOrNot={AccessOrNot} postId={props.state.post_id} CrownReturn={CrownReturn} />
                )}

                {msg.type === "products" && (
                  <div>{/* reuse your existing products template editor here */}</div>
                )}
              </Card>
            ))}

            {/* Add Message Button */}
            <Button
              type="dashed"
              block
              disabled={(props.state.auto_reply.messages || []).length >= 10}
              onClick={() => {
                console.log("===PROPS STATE===", props.state.auto_reply.followers_only != true , props.state.auto_reply.welcome_message?.enabled != true)
                if(props.state.auto_reply.followers_only != true && props.state.auto_reply.welcome_message?.enabled != true && props.state.auto_reply.messages?.length >= 1){

                  alert("Enable welcome message to use DM Sequences.")
                  return
                }
                let messages = props.state.auto_reply.messages || [];
                messages.push({ type: "text", delay: 0, dms: [""], buttons:[{ title: "click to edit", url: "", type: "web_url" },] });
                props.setData({
                  ...props.state,
                  auto_reply: { ...props.state.auto_reply, messages }
                });
              }}
            >
              + Add Message
            </Button>
          </>
        )}
      </div>
      }



      {/* Smart mode */}


      <Collapse style={{ backgroundColor: 'white', width: '100%', margin: '0 auto' }}
        defaultActiveKey={['0']}
        items={[
          {
            key: '1',
            label: "🔥 Enable Smart Trending Mode. Highly recommened for creators who gets 20k+ views.",
            children: <div className="action-box">

              {
                !AccessOrNot("smart_mode") &&
                <Button style={{ backgroundColor: "black", color: 'white', padding: '10px' }} onClick={() => props.setShowplan(true)} color="default" variant="solid" block>🔥 Upgrade plan to Access these safety features</Button>
              }
              <h4>
                <FireFilled style={{ color: 'orange' }} className="icon delay" /> Smart Trending Mode  <CrownReturn premiumUser={AccessOrNot("smart_mode")} />
              </h4>

              <p>Smart Trending Mode keeps your account safe by managing rate limits, handling errors, toggling comment replies, and supporting scheduled replies to avoid blocks.</p>

              <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between', alignItems: 'center', alignItems: 'center' }}>
                <h4>Trending Mode <CrownReturn premiumUser={AccessOrNot("smart_mode")} /></h4>
                <Switch style={{ marginTop: '20px' }} value={AccessOrNot("smart_mode")} disabled />
              </div>
              <p>Trending Mode helps prevent account blocks by avoiding excessive replies in a short time.</p>

              <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between', alignItems: 'center', alignItems: 'center' }}>
                <h4>Instagram Safety Limit <CrownReturn premiumUser={AccessOrNot("smart_mode")} /></h4>
                <Switch style={{ marginTop: '20px' }} value={AccessOrNot("smart_mode")} disabled />
              </div>

              <p>Instagram enforces limits on replies per hour for account safety. This mode helps you stay within those limits.</p>

              <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between', alignItems: 'center', alignItems: 'center' }}>
                <h4>Smart Failed DM Handler <CrownReturn premiumUser={AccessOrNot("smart_mode")} /></h4>
                <Switch style={{ marginTop: '20px' }} value={AccessOrNot("smart_mode")} disabled />
              </div>

              <p>Our smart handler reprocesses failed DMs, ensuring a higher delivery rate.</p>

              <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between', alignItems: 'center', alignItems: 'center' }}>
                <h4>Smart Comment Reply Toggle <CrownReturn premiumUser={AccessOrNot("smart_mode")} /></h4>
                <Switch style={{ marginTop: '20px' }} value={AccessOrNot("smart_mode")} disabled />
              </div>

              <p>This feature automatically toggles comment replies on and off to maintain account safety.</p>

              <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between', alignItems: 'center', alignItems: 'center' }}>
                <h4>Smart Welcome Message <CrownReturn premiumUser={AccessOrNot("smart_mode")} /></h4>
                <Switch style={{ marginTop: '20px' }} value={AccessOrNot("smart_mode")} disabled />
              </div>

              <p>Send a smart welcome message to improve delivery success rates.</p>

              <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between', alignItems: 'center', alignItems: 'center' }}>
                <h4>Smart Slowdown Mode <CrownReturn premiumUser={AccessOrNot("smart_mode")} /></h4>
                <Switch style={{ marginTop: '20px' }} value={AccessOrNot("smart_mode")} disabled />
              </div>

              <p>Distribute sudden influxes of comments over multiple time windows for hourly processing.</p>

              {
                !AccessOrNot("smart_mode") &&
                <Button style={{ backgroundColor: "black", color: 'white', padding: '10px' }} onClick={() => props.setShowplan(true)} color="default" variant="solid" block>🔥 Upgrade plan to Access these safety features</Button>
              }

            </div>
          }
        ]} />



      {/* Additional settings */}
      {
        !props.isStory &&
        <div className="action-box">
          <h4>
            <ClockCircleOutlined className="icon delay" /> Additional Settings
          </h4>
          <p>Configure additional options for your automation</p>

          <h3>Reply Delay <CrownReturn premiumUser={AccessOrNot("reply_delay")} /> </h3>
          <Radio.Group disabled={!AccessOrNot("reply_delay")} onChange={(e) => { props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, delay: e.target.value } }) }} value={props.state.auto_reply.delay || "0"}>
            <Radio.Button value="0">Immediate</Radio.Button>
            <Radio.Button value="10">10 Sec</Radio.Button>
            <Radio.Button value="30">30 Sec</Radio.Button>
            <Radio.Button value="60">1 Min</Radio.Button>
          </Radio.Group>
          <p style={{ fontSize: '12px' }}>{props.isDMAuto ? "DM Reply will be" : "DM & Comment automation will be"} {(props.state.auto_reply.delay == 0 || props.state.auto_reply.delay == undefined) ? "Proccessed Immediately" : `delayed by ${props.state.auto_reply.delay} Seconds`}</p>


          {/* <TextArea rows={6} value={ props.state.auto_reply.dms.length > 0 ? props.state.auto_reply.dms[0] :'' } onChange={(e) =>  
            props.setData({...props.state , auto_reply:{...props.state.auto_reply , dms:[e.target.value]}}) }
              placeholder="Enter message here..." maxLength={1000} showCount /> */}
        </div>
      }



      <a target="_blank" href="https://instagram.com/code_with_ssk">Missing any features or need any additional features? send us a message in Instagram!</a>
      <div style={{ marginBottom: '40px' }}></div>
    </div>
      {/* <div className="mobile" style={{flex:"1"}}>
        <CommentPreview igData={props.igData} data = {props.state} />
      </div> */}
    </div>
  );
}

function AutoHide(props) {


  const [tags, setTags] = useState([]);
  const [inputVisible, setInputVisible] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const inputRef = useRef(null);
  useEffect(() => {
    if (inputVisible) {
      inputRef.current?.focus();
    }
  }, [inputVisible]);
  const handleClose = (removedTag) => {
    const newTags = props.state.auto_reply.triger_words.filter((tag) => tag !== removedTag);
    // console.log(newTags);
    props.setData({ ...props.state, auto_reply: { ...props.state.auto_reply, triger_words: newTags } })
    // setTags(newTags);
  };
  const showInput = () => {
    setInputVisible(true);
  };
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };
  const handleInputConfirm = () => {
    if (inputValue && tags.indexOf(inputValue) === -1) {
      setTags([...tags, inputValue]);
    }
    setInputVisible(false);
    setInputValue('');
  };


  const forMap = (tag) => (
    <span
      key={tag}
      style={{
        display: 'inline-block',
      }}
    >
      <Tag
        style={{ padding: '10px 10px', fontSize: '14px', gap: '10px' }}
        color="blue"
        closable
        onClose={(e) => {
          e.preventDefault();
          handleClose(tag);
        }}
      >
        {tag}
      </Tag>
    </span>
  );

  const tagChild = tags.map(forMap);
  const tagPlusStyle = {
    background: 'blue',
    borderStyle: 'dashed',
  };

  return (
    <div className="drawer-item">

      <div className="action-box">
        <h4><ThunderboltOutlined className="icon thunder" /> Trigger: When audience commented</h4>
        <p>Automatically hide comments containing abusive or sensitive words. You can customize the hidden message with up to 30 words to fit your needs.</p>
        <div className="flex-divider">
          {inputVisible ? (
            <Input
              placeholder="Expected Word"
              ref={inputRef}
              type="text"
              size="large"
              style={{
                width: "200px",
              }}
              value={inputValue}
              onChange={handleInputChange}
              onBlur={handleInputConfirm}
              onPressEnter={handleInputConfirm}
            />
          ) : (
            <Tag className="add-new-tag" onClick={showInput} >
              <PlusOutlined />Expected Word
            </Tag>
          )}
          <div>
            {tagChild}
          </div>
        </div>

      </div>

      <div className="action-box">
        <h4>
          <EyeInvisibleOutlined className="icon hide" /> Action : Hide the comments
        </h4>
        <p>This action will auto delete the comment if any mathing words found.</p>
      </div>

    </div>
  )


}

function AutoDelete() {


  const [tags, setTags] = useState([]);
  const [inputVisible, setInputVisible] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const inputRef = useRef(null);
  useEffect(() => {
    if (inputVisible) {
      inputRef.current?.focus();
    }
  }, [inputVisible]);
  const handleClose = (removedTag) => {
    const newTags = tags.filter((tag) => tag !== removedTag);
    // console.log(newTags);
    setTags(newTags);
  };
  const showInput = () => {
    setInputVisible(true);
  };
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };
  const handleInputConfirm = () => {
    if (inputValue && tags.indexOf(inputValue) === -1) {
      setTags([...tags, inputValue]);
    }
    setInputVisible(false);
    setInputValue('');
  };


  const forMap = (tag) => (
    <span
      key={tag}
      style={{
        display: 'inline-block',
      }}
    >
      <Tag
        style={{ padding: '10px 10px', fontSize: '14px', gap: '10px' }}
        color="blue"
        closable
        onClose={(e) => {
          e.preventDefault();
          handleClose(tag);
        }}
      >
        {tag}
      </Tag>
    </span>
  );

  const tagChild = tags.map(forMap);
  const tagPlusStyle = {
    background: 'blue',
    borderStyle: 'dashed',
  };

  return (
    <div className="drawer-item">

      <div className="action-box">
        <h4><ThunderboltOutlined className="icon thunder" /> Trigger: When audience commented</h4>

        <p>Automatically delete comments containing predefined abusive or sensitive keywords to maintain a safe and respectful community environment.</p>
        <div className="flex-divider">
          {inputVisible ? (
            <Input
              placeholder="Expected Word"
              ref={inputRef}
              type="text"
              size="large"
              style={{
                width: "200px",
              }}
              value={inputValue}
              onChange={handleInputChange}
              onBlur={handleInputConfirm}
              onPressEnter={handleInputConfirm}
            />
          ) : (
            <Tag className="add-new-tag" onClick={showInput} >
              <PlusOutlined />Expected Word
            </Tag>
          )}
          <div>
            {tagChild}
          </div>
        </div>

      </div>
      <div className="action-box">
        <h4>
          <DeleteOutlined className="icon delete" /> Action : Delete the comments
        </h4>
        <p>This action will auto delete the comment if any mathing words found.</p>
      </div>

    </div>
  )


}

export { AutoReply, AutoHide, AutoDelete }